import React from "react";
import { useAccountDetailsContext } from "../AccountDetailsContainer";
import PaymentMethods from "../../shared/components/PaymentMethods";

const PaymentMethodSection = ({ onSuccess, compact = false, showExistingOnly = false }) => {
  const { team, csrfToken, stripePublishableKey } = useAccountDetailsContext();

  return (
    <PaymentMethods
      teamId={team.id}
      csrfToken={csrfToken}
      stripePublishableKey={stripePublishableKey}
      onSuccess={onSuccess}
      mode="manage"
      compact={compact}
      showHeader={!compact}
      showEmptyState={!compact}
      showAddButton={!showExistingOnly}
    />
  );
};

export default PaymentMethodSection;
